import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    redirect: '/hato-drop'
  },
  {
    path: '/hato-drop',
    name: 'Otoshi',
    // component: () => import(/* webpackChunkName: "about" */ '../components/Ammo.vue')
    // component: () => import(/* webpackChunkName: "about" */ '../components/AmmoJapanStack2.vue')
    // component: () => import(/* webpackChunkName: "about" */ '../components/AmmoJapanStack3.vue')
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  // {
  //   path: '/path',
  //   name: 'Ammo',
  //   component: () => import(/* webpackChunkName: "about" */ '../components/AmmoPath.vue')
  // },
  // {
  //   path: '/stack',
  //   name: 'Ammo',
  //   component: () => import(/* webpackChunkName: "about" */ '../components/AmmoStack.vue')
  // },
  // {
  //   path: '/jpstack',
  //   name: 'Ammo',
  //   component: () => import(/* webpackChunkName: "about" */ '../components/AmmoJapanStack.vue')
  // },
  // {
  //   path: '/enable3d',
  //   name: 'Ammo',
  //   component: () => import(/* webpackChunkName: "about" */ '../components/Enable3D.vue')
  // },
  // {
  //   path: '/matter',
  //   name: 'Matter',
  //   component: () => import(/* webpackChunkName: "about" */ '../components/Matter.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

export default router
